import { useState, useEffect } from 'react';

const galleryImages = [
  { src: '/assets/el-proyecto/concepto.jpg',  alt: 'Concepto arquitectónico' },
  { src: '/assets/el-proyecto/spa.jpg',       alt: 'Spa y bienestar' },
  { src: '/assets/el-proyecto/parrillas.jpg', alt: 'Zona de parrillas' },
];

const stats = [
  { value: '14 min', label: 'Al centro de Baños del Inca' },
  { value: '10',     label: 'Casas disponibles' },
  { value: '410 m²', label: 'Terreno por unidad' },
  { value: '100%',   label: 'Diseño arquitectónico premium' },
];

export default function About() {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    if (!lightbox) return;
    const onScroll = () => setLightbox(null);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lightbox]);

  return (
    <section id="el-proyecto" className="px-8 md:px-16 py-20">

      {/* Heading row */}
      <div className="grid md:grid-cols-2 gap-12 items-start mb-14">
        <h2 className="text-3xl md:text-4xl font-bold text-black leading-tight">
          Condominio Resort<br/>
          <span className="font-light italic">de lujo privado</span>
        </h2>
        <div>
          <p className="text-gray-500 leading-relaxed font-light">
            Bienvenido a <strong className="text-black font-semibold">"El Alto de los Bosques"</strong>, tu paraíso privado en una de las maravillas del Perú. Un exclusivo proyecto de casas de campo en un ambiente natural de lujo, pensado para quienes buscan disfrutar del campo, la naturaleza y el confort en una nueva forma de vivir.
          </p>
          <p className="text-gray-500 leading-relaxed font-light mt-4">
            Combina diseño moderno, acabados premium y una ubicación privilegiada en <strong className="text-black font-medium">Baños del Inca, Cajamarca</strong>. Los propietarios también podrán generar ingresos a través del alquiler vacacional.
          </p>
        </div>
      </div>

      {/* Gallery */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-16">
        {galleryImages.map((img) => (
          <div key={img.alt} className="group relative aspect-[4/3] overflow-hidden rounded-2xl">
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <button
              onClick={() => setLightbox(img)}
              className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full
                bg-black/30 backdrop-blur-sm border border-white/20
                flex items-center justify-center
                opacity-100 md:opacity-0 md:group-hover:opacity-100
                hover:bg-black/60 hover:scale-110
                transition-all duration-200"
              aria-label="Ver imagen completa"
            >
              <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-5h-4m4 0v4m0-4l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* Stats bar */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-10 border-t border-gray-100">
        {stats.map((s) => (
          <div key={s.label}>
            <p className="text-3xl font-bold text-black">{s.value}</p>
            <p className="text-sm text-gray-400 mt-1 font-light leading-snug">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightbox.src}
              alt={lightbox.alt}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 inset-x-0 px-5 py-4 bg-gradient-to-t from-black/70 to-transparent">
              <p className="text-white font-semibold text-sm">{lightbox.alt}</p>
            </div>
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/40 backdrop-blur-sm
                border border-white/20 flex items-center justify-center
                hover:bg-black/70 hover:scale-110 transition-all duration-200"
              aria-label="Cerrar"
            >
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
      )}

    </section>
  );
}
